var map = {
	"./news-2025-1.jpg": 46113,
	"./news-2025-10.jpg": 76253,
	"./news-2025-2.jpg": 53974,
	"./news-2025-3.jpg": 98739,
	"./news-2025-4.jpg": 8576,
	"./news-2025-5.jpg": 60317,
	"./news-2025-6.jpg": 22514,
	"./news-2025-7.jpg": 98895,
	"./news-2025-8.jpg": 91084,
	"./news-2025-9.jpg": 5225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14513;